export default "__VITE_ASSET__Bwlxuqlo__"